var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3777 7.96196C18.9115 8.85968 20.8826 8.34408 21.7803 6.81033C22.678 5.27658 22.1624 3.30548 20.6287 2.40776C19.0949 1.51003 17.1238 2.02564 16.2261 3.55939C15.3284 5.09314 15.844 7.06424 17.3777 7.96196Z",
    stroke: "#24242D",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26054 16.0644C4.79429 16.9621 6.76539 16.4465 7.66311 14.9127C8.56084 13.379 8.04523 11.4079 6.51148 10.5102C4.97773 9.61245 3.00663 10.1281 2.10891 11.6618C1.21119 13.1956 1.72679 15.1667 3.26054 16.0644Z",
    stroke: "#24242D",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3777 24.3268C18.9115 25.2245 20.8826 24.7089 21.7803 23.1751C22.678 21.6414 22.1624 19.6703 20.6287 18.7726C19.0949 17.8748 17.1238 18.3904 16.2261 19.9242C15.3284 21.4579 15.844 23.429 17.3777 24.3268Z",
    stroke: "#24242D",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80224 12.0035L16.1833 6.85009",
    stroke: "#24242D",
    strokeWidth: 2.08333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80224 15.8535L16.1833 21.0069",
    stroke: "#24242D",
    strokeWidth: 2.08333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.c9958fd0574ef6aa0f691fa125f6b222.svg";
export { ForwardRef as ReactComponent };